export const summaryRows: string[] = [
  'Volume 1 — Fondamenti di Scienze Forensi',
  'Volume 2 — Scena del Crimine e Raccolta delle Prove',
  'Volume 3 — Impronte Digitali, Segni e Tracce',
  'Volume 4 — Biologia Forense, DNA, Patologia e Antropologia',
  'Volume 5 — Chimica Forense e Tossicologia',
  'Volume 6 — Informatica Forense e Ricostruzione del Caso',
  'Bonus 1 — 150 Attività e Sfide di Scienze Forensi per la Classe',
  'Bonus 2 — Banca di Verifiche e Valutazioni di Scienze Forensi',
  'Bonus 3 — 100 Casi di Studio e Scenari di Problem Solving',
  'Bonus 4 — Dizionario del Docente: 200 Concetti Essenziali',
  'Bonus 5 — 100 Sfide di Pensiero Critico e Discussione',
  'Garanzia di soddisfazione di 7 giorni',
  'Accesso immediato',
];
